export default __webpack_public_path__ + "static/media/cebisa.6457dc54.svg";